import {
  Academics,
  Internet,
  Food,
  Travel,
  Transport,
  Health,
  Electric,
  Cloth,
  Rent,
  Shopping,
} from './components/icons/Icons';

export const categories = [
  {
    id: 1,
    category: 'Education',
    icon: <Academics />,
  },
  {
    id: 2,
    category: 'Food',
    icon: <Food />,
  },
  {
    id: 3,
    category: 'Travel',
    icon: <Travel />,
  },
  {
    id: 4,
    category: 'Cloth',
    icon: <Cloth />,
  },
  {
    id: 5,
    category: 'Health',
    icon: <Health />,
  },
  {
    id: 6,
    category: 'Transport',
    icon: <Transport />,
  },
  {
    id: 7,
    category: 'Internet',
    icon: <Internet />,
  },
  {
    id: 8,
    category: 'Shopping',
    icon: <Shopping />,
  },
  {
    id: 9,
    category: 'Rent',
    icon: <Rent />,
  },
  {
    id: 10,
    category: 'Electricity',
    icon: <Electric />,
  },
];
